
export const consts = {
    GENERAL: {
        TITLE: 'Crypto Market',
        LOW: 'Low',
        HIGH: 'High'
    },
    HOME: {
        SEARCH: 'Filter a crypto coin',
        SUBTITLE: 'Top 100 Cryptocurrency Prices',
        MARKET_CAP: 'Market Cap',
        CHANGE_IN_LAST_24H: 'change in the last 24h',
        CURRENT_PRICE: 'Current Price',
        HIGH_LOW_IN_24H: 'High/Low in 24h',
        PRICE_CHANGE_IN: 'Price Change in',
        CIRCULATING_SUPPLY: 'Circulating Supply',
        TOTAL_SUPPLY: 'Total Supply',
        NONE: 'None.',
        ATH: 'ATH'
    },
    MARKET_CAP_LIST: {
        NAME: 'Name',
        PRICE: 'Price',
        MARKET_CAP: 'Market cap',
        CIRCULATING_SUPPLY: 'Circulating Supply',
        MAX_SUPPLY: 'Max supply',
        TOTAL_SUPPLY: 'Total supply',
        ATH: 'ATH'
    },
    COMPONENTS: {
        COPY_TO_CLIPBOARD: 'Copy to clipboard',
        COPY_TO_CLIPBOARD_SUCCESSFULL: 'Copied to clipboard!'
    },
    DETAIL: {
        CONTRACTS: 'Contracts',
        RANK: 'Rank',
        TAGS: 'Tags',
        SITE: 'Site',
        DESCRIPTION: 'Description',
        CIRCULATING_SUPPLY: 'Circulating supply',
        CIRCULATING_SUPPLY_TOOLTIP: 'The amount of coins that are circulating in the market and are in public hands. It is analogous to the flowing shares in the stock market.',
        MAX_SUPPLY: 'Max supply',
        MAX_SUPPLY_TOOLTIP: 'The maximum amount of coins that will ever exist in the lifetime of the cryptocurrency. It is analogous to the fully diluted shares in the stock market. If this data has not been submitted by the project or verified by the CMC team, max supply shows.',
        TOTAL_SUPPLY: 'Total supply',
        TOTAL_SUPPLY_TOOLTIP: 'The amount of coins that have been already created, minus any coins that have been burned. It is analogous to the outstanding shares in the stock market. If this data has not been submitted by the project or verified by the CMC team, total supply shows.',
        PRICE_OF: 'Price of',
        MARKET_CAP: 'Market cap',
        MARKET_CAP_TOOLTIP: 'The total market value of a circulating supply cryptocurrency. It is analogous to the free-float capitalization in the stock market. Market Cap = Current Price x Circulating Supply.',
        FULLY_DILUTED_MARKET_CAP: 'Fully Diluted Market Cap',
        FULLY_DILUTED_MARKET_CAP_TOOLTIP: 'The market cap if the max supply was in circulation. Fully-diluted market cap (FDMC) = price x max supply. If max supply is null, FDMC = price x total supply. if max supply and total supply are infinite or not available, fully-diluted market cap shows.',
        ATH_TOOLTIP: 'Stands for "all-time high." In cryptocurrency and online trading, the ATH is the highest price or market capitalization that a particular asset has reached in its entire history, since its listing.'
    },
    ABOUT: {
        CREATED_BY: 'Created by',
        SOFTWARE_DEVELOPER: 'Software developer for more than 15 years',
        YOU_CAN_FIND_ME: 'You can find me on Twitter'
    }
}